import React from 'react';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import CommunicationService from '../services/CommunicationService';

interface CommunicationButtonsProps {
  variant?: 'support' | 'share' | 'contact' | 'emergency';
  size?: 'sm' | 'lg';
  className?: string;
  data?: any;
}

/**
 * Reusable Communication Buttons Component
 */
const CommunicationButtons: React.FC<CommunicationButtonsProps> = ({
  variant = 'support',
  size,
  className = '',
  data = {}
}) => {

  const handleSupport = async (channel: 'email' | 'sms' | 'whatsapp') => {
    try {
      await CommunicationService.contactSupport(
        data.userName || 'User',
        data.userPhone || '',
        data.issueType || 'General Support',
        data.issueDescription || '',
        channel
      );
    } catch (error) {
      console.error('Error contacting support:', error);
    }
  };

  const handleEventShare = async (channel: 'email' | 'sms' | 'whatsapp') => {
    try {
      await CommunicationService.shareEvent(
        data.eventName,
        data.eventDate,
        data.eventTime,
        data.venue,
        data.bookingUrl || window.location.href,
        data.recipientPhone,
        channel
      );
    } catch (error) {
      console.error('Error sharing event:', error);
    }
  };

  const handleOrganizerContact = async (channel: 'email' | 'sms' | 'whatsapp') => {
    try {
      console.log('Contacting organizer with data:', data);
      await CommunicationService.contactOrganizer(
        data.organizerName || 'Organizer',
        data.organizerPhone || '',
        data.eventName || 'Event',
        data.eventDate || 'TBD',
        data.eventTime || 'TBD',
        data.venue || 'TBD',
        data.customerName || 'Customer',
        data.customerPhone || '',
        data.customerEmail || '',
        channel,
        data.organizerEmail || ''
      );
    } catch (error) {
      console.error('Error contacting organizer:', error);
    }
  };

  const handleEmergency = async (channel: 'email' | 'sms' | 'whatsapp') => {
    try {
      await CommunicationService.emergencyContact(
        data.userName,
        data.userPhone,
        data.issueType || 'Emergency',
        data.issueDescription || '',
        data.bookingCode,
        data.eventName,
        data.eventDate,
        channel
      );
    } catch (error) {
      console.error('Error with emergency contact:', error);
    }
  };

  if (variant === 'support') {
    return (
      <Dropdown as={ButtonGroup} className={className}>
        <Button
          variant="outline-primary"
          size={size}
          onClick={() => handleSupport('whatsapp')}
        >
          <i className="bi bi-headset me-1"></i>
          Support
        </Button>
        <Dropdown.Toggle split variant="outline-primary" size={size} />
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => handleSupport('whatsapp')}>
            <i className="bi bi-whatsapp text-success me-2"></i>
            WhatsApp
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleSupport('sms')}>
            <i className="bi bi-chat-dots text-primary me-2"></i>
            SMS
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleSupport('email')}>
            <i className="bi bi-envelope text-warning me-2"></i>
            Email
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  if (variant === 'share') {
    return (
      <Dropdown as={ButtonGroup} className={className}>
        <Button
          variant="outline-success"
          size={size}
          onClick={() => handleEventShare('whatsapp')}
        >
          <i className="bi bi-share me-1"></i>
          Share
        </Button>
        <Dropdown.Toggle split variant="outline-success" size={size} />
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => handleEventShare('whatsapp')}>
            <i className="bi bi-whatsapp text-success me-2"></i>
            WhatsApp
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleEventShare('sms')}>
            <i className="bi bi-chat-dots text-primary me-2"></i>
            SMS
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleEventShare('email')}>
            <i className="bi bi-envelope text-warning me-2"></i>
            Email
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  if (variant === 'contact') {
    return (
      <Dropdown as={ButtonGroup} className={className}>
        <Button
          variant="outline-info"
          size={size}
          onClick={() => handleOrganizerContact('whatsapp')}
        >
          <i className="bi bi-person-lines-fill me-1"></i>
          Contact
        </Button>
        <Dropdown.Toggle split variant="outline-info" size={size} />
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => handleOrganizerContact('whatsapp')}>
            <i className="bi bi-whatsapp text-success me-2"></i>
            WhatsApp
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleOrganizerContact('sms')}>
            <i className="bi bi-chat-dots text-primary me-2"></i>
            SMS
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleOrganizerContact('email')}>
            <i className="bi bi-envelope text-warning me-2"></i>
            Email
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  if (variant === 'emergency') {
    return (
      <Button
        variant="danger"
        size={size}
        className={className}
        onClick={() => handleEmergency('whatsapp')}
      >
        <i className="bi bi-exclamation-triangle me-1"></i>
        Emergency
      </Button>
    );
  }

  return null;
};

export default CommunicationButtons;